export const isOnlyMobbfun = window.location.hostname.includes('mobbfun')  
//  || window.location.hostname.includes('localhost')
 ? true : false


// WEBPACK FOOTER //
// ./src/constants/isOnlyMobbfun.js